import ManagerState from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state: ManagerState = {
  baseData: {
    start: 1,
    count: 0,
    total: 0
  },
  articles: [],
  categoryData: [],
  categoryWholeData: undefined,
  kajikiData: [],
  accountData: undefined,
  storageData: {
    storage: {
      total: 0,
      use: 0
    }
  },
  modalState: undefined,
  siteUrlModel: undefined,
  loading: {
    kajiki: true,
    article: true
  }
}

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
}
